import {HTTP} from '../../utils/http';

export const SchoolSettingsService = {

    getSchoolSettings(schoolId) {
        return HTTP.get(`/schools/${schoolId}/settings`);
    },

    getSchoolsParentPortalInfo(schoolId) {
        return HTTP.get(`/schools/${schoolId}/parent-portal-info`);
    },

    updateTagLine(schoolId, tagLine) {
        return HTTP.patch(`/schools/${schoolId}/tag-line`, { tagLine });
    },

    getPortalName(schoolId) {
        return HTTP.get(`/schools/${schoolId}/portal-name`);
    },

    updatePortalName(schoolId, portalName) {
        return HTTP.patch(`/schools/${schoolId}/portal-name`, { portalName });
    },

    checkPortalName(schoolId, portalName) {
        return HTTP.get(`/schools/${schoolId}/check-portal?portalName=${portalName}`);
    },

    changeLogo(schoolId, file) {
        const headers = {'Content-Type': 'multipart/form-data'};
        const formData = new FormData();
        formData.append('image', file);
        return HTTP.patch(`/schools/${schoolId}/background-image`, formData, { headers });
    }
};


// WEBPACK FOOTER //
// ./src/common/services/settings/school-settings.service.js